import AuthorSVG from 'assets/brand/avatar-author.svg';
export var getAvatarSrc = function (profile, size) {
    var _a, _b, _c;
    if (!profile)
        return;
    return (_c = (_b = (_a = profile.Media) === null || _a === void 0 ? void 0 : _a.sizes[size]) !== null && _b !== void 0 ? _b : profile.avatar) !== null && _c !== void 0 ? _c : AuthorSVG;
};
